<template>
  <section
    v-if="contextData"
    class="bg-gradient-to-b from-blue-400/10 to-green-400/10"
  >
    <SuiteSuiteCard
      :item-data="contextData"
      :url-connector="urlConnector"
      class="container-wrap py-9 tablet:py-12"
    />
  </section>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IButton {
    text: string;
    link: string;
    trackingCode?: string;
  }

  interface ISuiteData {
    title: string;
    subTitle?: string;
    description: string;
    buttons: IButton[];
    thumbnail: string;
    wistiaCode?: string;
  }

  interface ISuite {
    component: 'suite';
    meta: {
      navigable?: string;
    };
    data: ISuiteData;
  }

  type IProps = ISuiteProps<ISuite>;

  const props = defineProps<IProps>();

  const contextData = computed((): ISuiteData => props.suiteData.data);

  export type { IButton, ISuite, ISuiteData };
</script>
